import { render, staticRenderFns } from "./AddClassifiedAd.vue?vue&type=template&id=99fdf0a0&scoped=true&"
import script from "./AddClassifiedAd.vue?vue&type=script&lang=js&"
export * from "./AddClassifiedAd.vue?vue&type=script&lang=js&"
import style0 from "./AddClassifiedAd.vue?vue&type=style&index=0&id=99fdf0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fdf0a0",
  null
  
)

export default component.exports